// Written in this round about way for babel-transform-imports
import MemoryRouter from "react-router/es/MemoryRouter";

export default MemoryRouter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/MemoryRouter.js
// module id = 652
// module chunks = 0